import { Box } from '@mui/material'
import { Select } from 'packages/eid-ui'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FieldItemWrapper from '../Components/FieldItemWrapper'
import RequiredFieldErrorMessage from '../Components/FieldItemWrapper/RequiredFieldErrorMessage'
import classNames from 'classnames'
import { getFieldTypeRequiredErrorMessage } from 'packages/core'
import InfoMessageForWrongJson from '../Components/InfoMessageForWrongJson'



const SingleSelectDropdownList = ({
    fieldType,
    isFormValidated,
    valueType,
    isApiSupportedSource,
    useDataHook,
    handleUpdate,
}) => {
    const { t } = useTranslation()
    const [sourceValues, setSourceValues] = useState([])
    const [showFieldValues, setShowFieldValues] = useState(true)
    const [errorMessage, setErrorMessage] = useState('')
    const [sourceUpdated, setSourceUpdated] = useState(false)

    useEffect(() => {
        if (fieldType?.SourceValues && sourceUpdated) {
            setShowFieldValues(fieldType?.SourceValues?.length ? true : false)
            setSourceValues(fieldType?.SourceValues || [])
        }
    }, [fieldType?.SourceValues, sourceUpdated])

    useEffect(() => {
        if (isFormValidated && !fieldType?.[valueType]) {
            setErrorMessage(getFieldTypeRequiredErrorMessage(fieldType))
        } else {
            setErrorMessage('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFormValidated, fieldType?.[valueType]])

    const { data: sourceData, isFetching } = useDataHook(fieldType)

    useEffect(() => {
        if (isApiSupportedSource) {
            if (!isFetching) {
                updateSourceValues()
                setSourceUpdated(true)
            }
        } else {
            setShowFieldValues(fieldType?.SourceValues?.length ? true : false)
            setSourceValues(fieldType?.SourceValues || [])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isApiSupportedSource, isFetching])

    const updateSourceValues = () => {
        const valueToUpdate = {
            ...fieldType,
            SourceValues: sourceData?.data || [],
        }
        handleUpdate(valueToUpdate)
    }

    const getOptionLabel = (option) => option?.name || option?.value || ''

    const handleSelection = (selected) => {
        const valueToUpdate = {
            ...fieldType,
            [valueType]: selected
                ? { ValueName: selected.id, FriendlyName: selected.name }
                : null,
        }
        handleUpdate(valueToUpdate)
    }

    return (
        <FieldItemWrapper
            title={fieldType?.Name}
            isRequired={fieldType?.IsRequired}
            fieldTypeScope={fieldType?.FieldTypeScope}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2rem',
                    '& .MuiFormControl-root': {
                        marginTop: '0 !important',
                    },
                    '& .MuiSelect-select': {
                        boxShadow: '0 .4rem .6rem -2px rgba(0, 0, 0, 0.1)',
                        padding: '.9rem 1rem !important',
                        height: '2rem',
                        borderRadius: '.4rem !important',
                        borderColor: '#ebebed !important',
                        '& span': {
                            fontSize: '1.4rem',
                        },
                    },
                    '& p': {
                        minWidth: '36rem',
                    },
                    '& input': {
                        minWidth: '36rem',
                    },
                    '& .MuiInputBase-formControl': {
                        marginTop: '0 !important',
                        minWidth: '36rem',
                    },
                    '& svg': {
                        width: '2.4rem !important',
                    },
                    ...(Boolean(errorMessage) && {
                        '& .MuiSelect-select ': {
                            outline: '1px solid #d0021b',
                        },
                    }),
                    ...(fieldType?.IsReadOnly && {
                        pointerEvents: 'none',
                        '& .MuiSelect-select ': {
                            opacity: '.7',
                            cursor: 'not-allowed',
                        },
                    }),
                }}
            >
                {showFieldValues ? (
                    <Select
                        value={
                            fieldType?.[valueType]
                                ? {
                                      id: fieldType?.[valueType]?.ValueName,
                                      name: fieldType?.[valueType]
                                          ?.FriendlyName,
                                      value: fieldType?.[valueType]?.ValueName,
                                  }
                                : null
                        }
                        options={
                            sourceValues?.length
                                ? sourceValues.map((item) => {
                                      return {
                                          id: item.ValueName,
                                          name: item.FriendlyName,
                                          value: item.ValueName,
                                          description: item.Description,
                                      }
                                  })
                                : []
                        }
                        getOptionLabel={getOptionLabel}
                        onChange={(e) => handleSelection(e)}
                        placeholder={t('Common_SelectFieldValue')}
                        isLoading={isFetching}
                        disabled={fieldType?.IsReadOnly}
                        showInfoTooltip={true}
                    />
                ) : (
                    <InfoMessageForWrongJson />
                )}
            </Box>
            <Box>
                {Boolean(errorMessage) && (
                    <RequiredFieldErrorMessage errorMsgKey={errorMessage} />
                )}
            </Box>
        </FieldItemWrapper>
    )
}

export default SingleSelectDropdownList
